import api from "../lib/api";
import { Pagination } from "../models/base.model";
import { INotification } from "../models/notification.model";

export async function getNotifications(filter?: Pagination) {
  const searchParams = new URLSearchParams();

  if (filter) {
    Object.keys(filter).forEach((key) => {
      const value = filter[key as keyof Pagination];
      if (typeof value !== "undefined" && value !== null) {
        if (key === "filter") {
          searchParams.set("filter", JSON.stringify(value));
        } else {
          searchParams.set(key, value.toString());
        }
      }
    });
  }

  return api<{
    notifications: INotification[];
  }>({
    url: `/notifications?${searchParams.toString()}`,
    method: "GET",
  });
}

export async function readNotifications(ids: string[]) {
  return api<{
    success: boolean;
  }>({
    url: `/notifications/read`,
    method: "PUT",
    data: { ids },
  });
}
